import { MenuLink, Wrapper, Button, NewLink } from "./styled";
import Contact from "../../constants";

const MenuLinks = ({ handleLinkClick, scrollToUp }) => {
  return (
    <Wrapper id="menu-glowne">
      <NewLink
        to="/"
        onClick={() => {
          scrollToUp();
          handleLinkClick();
        }}
      >
        Start
      </NewLink>
      <MenuLink href="/#wybierz-cel" onClick={handleLinkClick}>
        Oferta
      </MenuLink>
      <MenuLink href="/narzedzia/" target="_blank" rel="noopener noreferrer" onClick={handleLinkClick}>
        Narzędzia
      </MenuLink>
      <NewLink to="/przed-decyzja" onClick={handleLinkClick}>
        Przed decyzją
      </NewLink>
      <MenuLink href="/#kontakt" onClick={handleLinkClick}>
        Kontakt
      </MenuLink>
      <MenuLink href={`tel:${Contact.PHONE}`} onClick={handleLinkClick}>
        📞 783 737 050
      </MenuLink>
      <Button to="/#formularz" data-contact-cta onClick={handleLinkClick}>
        Umów rozmowę
      </Button>
    </Wrapper>
  );
};

export default MenuLinks;

